import * as yup from "yup";

export const enquirySchema = yup.object({
  brochure: yup.boolean(),
  price_list: yup.boolean(),
  showflat_appointment: yup.boolean(),
  
  // --- THIS IS THE FIX ---
  name: yup
    .string()
    .required("*Full Name is required")
    .matches(/^[a-zA-Z\s]+$/, "*Name must only contain letters and spaces"),
  // --- END OF FIX ---

  email: yup.string().email("*Invalid email").required("*Email is required"),
  
  mobile_number: yup
    .string()
    .required("*Contact Number is required")
    .matches(/^[0-9]+$/, "*Must be only digits")
    .test(
      "sg-mobile",
      "*Enter a valid Singapore mobile number (8 digits starting with 8 or 9)",
      (value) => {
        if (!value) return false;
        // Tolerate an optional 65 country code; SG mobiles are 8 digits
        // starting with 8 or 9.
        const local = value.replace(/^65/, "");
        return /^[89]\d{7}$/.test(local);
      }
    ),

  date: yup.string().when("showflat_appointment", {
    is: true,
    then: () =>
      yup
        .string()
        .required("*Appointment Date is required")
        .test(
          "is-future",
          "*Appointment Date must be in the future",
          (value) => {
            if (!value) return false;
            const selectedDate = new Date(value);
            const now = new Date();
            now.setHours(0, 0, 0, 0); 
            return selectedDate >= now;
          }
        ),
    otherwise: () => yup.string().nullable(),
  }),
  time: yup.string().when("showflat_appointment", {
    is: true,
    then: () => yup.string().required("*Appointment Time is required"),
    otherwise: () => yup.string().nullable(),
  }),
  
  // Optional — properties with no released price list have no flat types to
  // pick from, and we don't want that to block lead capture. When types ARE
  // available, the dropdown is rendered as a soft nudge (no asterisk).
  flat_type_id: yup.array().of(yup.string()).optional(),
});

export type EnquiryValidationType = yup.InferType<typeof enquirySchema>;